import React from 'react';

import ThrowError from '../../common/components/ThrowError';

export default function ErrorPage() {
    return <ThrowError />;
}
